var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-bg d-flex flex-column align-center justify-center"},[_c('div',[_c('div',{staticClass:"loader"},[_vm._v("Loading...")]),_c('p',[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }